import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import {
  Button,
  CircularProgress,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Input,
  ClickAwayListener,
  IconButton,
  InputBase,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';

import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  translate,
  convertPersianDigit2English,
  checkMatchMedia,
  OrderTransportationType,
  removeEmptyValueObject,
} from './helpers';
import { Status as OrderStatus } from '../pages/orders/interfaces';
import { OrderBundleStatus, StatusBundle as BundleStatus } from './helpers';
import { Status as CenterStatus } from '../pages/centers/interfaces';
import { Status as ParcelsState } from '../pages/parcels/interfaces';
import { mdiClose } from '@mdi/js';
import clsx from 'clsx';
import { mdiMagnify } from '@mdi/js/commonjs/mdi';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { flattenObject } from 'client-sdk/src/helpers';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

export type State = {
  classes: Function;
};
export type Props = {
  filters: Filter[];
  onFilter: any; //ToDo
  baseFilter: BaseFilter;
  filterValues: any;
  mainFiltersCount: number;
};

export type Category = string;

export type UserRole =
  | 'NONE'
  | 'DRIVER'
  | 'RONAD_ADMIN'
  | 'PARTNER_ADMIN'
  | 'CENTER_ADMIN'
  | 'MARKETING_MANAGER'
  | 'LOGISTICS_ADMIN'
  | 'WAREHOUSE_OPERATOR'
  | 'MARKETING_EXPERT'
  | 'OPERATIONS_MANAGER'
  | 'OPERATIONS_EXPERT'
  | 'SUPPORT_MANAGER'
  | 'AGENCY_ADMIN'
  | 'WAREHOUSE_ADMIN'
  | 'WAREHOUSE_SUPERVISOR'
  | 'SELLER_ADMIN'
  | 'FINANCIAL_SUPERVISOR'
  | 'SUPPORT_EXPERT';

export type BaseFilter = {
  type:
  | 'input'
  | 'select'
  | 'checkbox'
  | 'date-picker'
  | 'number'
  | 'time-picker'
  | 'date-picker-time';
  id: string;
  placeholder: string;
};

type ItemsStatusInventory =
  | 'PICKED'
  | 'CHECKED'
  | 'NOT_LOCATED'
  | 'LOCATED'
  | 'NOT_REGISTERED'
  | 'UNLOADED'
  | 'DELETED_BY_OPERATOR'
  | 'REGISTERED';

export type Filter = {
  type:
  | 'input'
  | 'select'
  | 'checkbox'
  | 'date-picker'
  | 'number'
  | 'time-picker'
  | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
  | OrderStatus[]
  | BundleStatus[]
  | UserRole[]
  | CenterStatus[]
  | ItemsStatusInventory[]
  | ParcelsState[]
  | OrderTransportationType[]
  | OrderBundleStatus[]
  | Category[];
  translateType?:
  | 'Order'
  | 'InventoryItemStatus'
  | 'Category'
  | 'Bundle'
  | 'UserRole'
  | 'CenterStatus'
  | 'ParcelsStatus'
  | 'FleetType'
  | 'EmploymentStatus'
  | 'VehicleType'
  | 'TransactionType'
  | 'TPL'
  | 'OrderBundleStatus'
  | 'CancellationTasks'
  | 'FleetStatus';
  icon?: any;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 5px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    inputWrapper: {
      flex: 7,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function RenderFilters(props: Props) {
  const [checkboxValue, setCheckboxValue] = useState([] as any[]);
  const classes = useStyles();
  const [init, setInit] = useState({} as any);
  const { filters, onFilter, baseFilter, filterValues, mainFiltersCount } = props;
  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const { register, handleSubmit, control, setValue, getValues, watch, reset } =
    useForm<any>();

  useEffect(() => {
    props.filters.map((item: any) => {
      if (item.type === 'date-picker-time' || item.type === 'date-picker') {
        register({ name: item.id }, { required: false });
      }
    });
  }, [register]);

  useEffect(() => {
    props.filters.map((item: any) => {
      if(item.type === 'checkbox' && filterValues[item.id]) {
        setCheckboxValue(filterValues[item.id].split(","))
      }
      setValue(item.id, filterValues[item.id]);
    });
  }, [openFilterBox]);

  // const handleSubmit = (e: React.FormEvent<HTMLInputElement>) => {
  //   e.preventDefault();
  // };
  const handleChange = (event: any) => {
    setCheckboxValue(event.target.value);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const renderFromItems = (filters: Record<string, any>[], props: any) => {
    const values = flattenObject(getValues());
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <Grid
          className={classes.root}
          container
          item
          spacing={2}
          xs={12}
          sm={6}
          key={index}
        >
          {(item.type === 'input' ||
            item.type === 'number' ||
            item.type === 'date-picker' ||
            'date-picker-time' ||
            item.type === 'checkbox' ||
            (item.type === 'select' && item.icon)) &&
            item.icon && (
              <Grid
                item
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <Icon path={item.icon} size={1} className={classes.icon} />
              </Grid>
            )}
          {item.type === 'input' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                inputRef={register({ required: false })}
                name={item.id}
                label={item.label}
                className={classes.textInput}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                inputRef={register({ required: false })}
                name={item.id}
                label={item.label}
                type={item.type}
                className={classes.textInput}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inputRef={register({ required: false })}
                      fullWidth
                      autoOk
                      variant="inline"
                      label={item.label}
                      className={classes.textInput}
                      format="YYYY/MM/DD"
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                          convertPersianDigit2English(
                            value.format('YYYY-MM-DD')
                          )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'time-picker' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <TimePicker
                      fullWidth
                      label={item.label}
                      variant="inline"
                      ampm={false}
                      format="HH:mm"
                      className={classes.textInput}
                      autoOk
                      clearable
                      labelFunc={date =>
                        date?.isValid() ? date.format('HH:mm') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                          convertPersianDigit2English(
                            value.format('jYYYY/jMM/jDD HH:mm')
                          )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'date-picker-time' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DateTimePicker
                      inputRef={register({ required: false })}
                      fullWidth
                      label={item.label}
                      variant="inline"
                      format="YYYY/MM/DD HH:mm"
                      autoOk
                      className={classes.textInput}
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid()
                          ? date.format('jYYYY/jMM/jDD HH:mm')
                          : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value && convertPersianDigit2English(value.format())
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}
          {item.type === 'select' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{ required: false }}
                  render={({ onChange, value }) => (
                    <Select
                      inputRef={register({ required: false })}
                      fullWidth
                      name={item.id}
                      className={classes.textInput}
                      onChange={e => {
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id] || ''}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                    >
                      <MenuItem aria-label="None" value="" />
                      {item.data.map((itemD: any, index: number) => (
                        <MenuItem value={itemD} key={index}>
                          {item.translateType === 'Order'? translate(itemD, 'order')
                            :item.translateType === 'ticket'? translate(itemD, 'ticket')
                              : item.translateType === 'UserRole'? translate(itemD, 'user')
                                : item.translateType === 'self'? itemD
                                  : item.translateType === 'ParcelsStatus'? translate(itemD, 'parcel')
                                   : item.translateType === 'FleetStatus'? translate(itemD, 'fleet')
                                      : item.translateType === 'VehicleType'? translate(itemD)
                                        : item.translateType === 'TransactionType'? translate(itemD)
                                          : item.translateType === 'TPL'? translate(itemD, "TPL")
                                            : item.translateType === 'OrderBundleStatus'? translate(itemD, 'order')
                                              : item.translateType === 'InventoryItemStatus'? translate(itemD, 'inventory')
                                                : item.translateType === 'CancellationTasks'? translate(itemD, 'bundle')
                                                  : item.translateType === 'EmploymentStatus'? translate(itemD, 'driver')
                                                    : item.translateType === 'fulfillmentLine'? translate(itemD): translate(itemD, 'bundle')}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
          {item.type === 'checkbox' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{ width: '100%' }}>
                <InputLabel id={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{ required: false }}
                  render={({ onChange, value }) => (
                    <Select
                      inputRef={register({ required: false })}
                      labelId={item.id}
                      id={item.id}
                      multiple
                      className={classes.textInput}
                      onChange={e => {
                        handleChange(e);
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id]?.split(',') || []}
                      input={<Input />}
                      name={item.id}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                      renderValue={(selected: any) => {
                        const nameSelectedItem = item.data.filter(
                          (status: any) => {
                            return selected.includes(status);
                          }
                        );

                        return nameSelectedItem
                          .map((nameSelect: any) =>
                            item.translateType === 'Order'? translate(nameSelect, 'order')
                              :item.translateType === 'ticket'? translate(nameSelect, 'ticket')
                                : item.translateType === 'UserRole'? translate(nameSelect, 'user')
                                  : item.translateType === 'Category'? nameSelect
                                    : item.translateType === 'CenterStatus' ? translate(nameSelect, 'center')
                                      : item.translateType === 'ParcelsStatus'? translate(nameSelect, 'parcel')
                                        : item.translateType === 'TPL'? translate(nameSelect, 'TPL')
                                          : item.translateType === 'OrderBundleStatus'? translate(nameSelect, 'order')
                                            : item.translateType === 'InventoryItemStatus'? translate(nameSelect, 'inventory')
                                              : item.translateType === 'FleetType'? translate(nameSelect, 'fleet')
                                                : item.translateType === 'CancellationTasks'? translate(nameSelect, 'bundle')
                                                  : item.translateType === 'COD'? translate(nameSelect, 'cod')
                                                    : item.translateType === 'SendDeliveryType'? translate(nameSelect)
                                                      : item.translateType === 'Quarantine'? translate(nameSelect, 'parcel')
                                                        : translate(nameSelect, 'bundle')
                          )
                          .join(',');
                      }}
                      MenuProps={MenuProps}
                    >
                      {item.data.map((itemD: any) => (
                        <MenuItem key={itemD} value={itemD}>
                          <Checkbox
                            checked={
                              checkboxValue.indexOf(itemD) > -1 
                            }
                          />
                          <ListItemText
                            primary={
                              // Todo
                              item.translateType === 'Order'? translate(itemD, 'order')
                                :item.translateType === 'ticket'? translate(itemD, 'ticket')
                                  : item.translateType === 'UserRole'? translate(itemD, 'user')
                                    : item.translateType === 'Category'? itemD
                                      : item.translateType === 'CenterStatus'? translate(itemD, 'center')
                                        : item.translateType === 'ParcelsStatus'? translate(itemD, 'parcel')
                                          : item.translateType === 'TPL'? translate(itemD, 'TPL')
                                            : item.translateType === 'OrderBundleStatus'? translate(itemD, 'order')
                                              : item.translateType === 'InventoryItemStatus'? translate(itemD, 'inventory')
                                                : item.translateType === 'FleetType'? translate(itemD, 'fleet')
                                                  : item.translateType === 'CancellationTasks'? translate(itemD, 'bundle')
                                                    : item.translateType === 'COD'? translate(itemD, 'cod')
                                                      : item.translateType === 'SendDeliveryType' ? translate(itemD)
                                                        : item.translateType === 'Quarantine'? translate(itemD, 'parcel')
                                                          : translate(itemD, 'bundle')
                            }
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      )
    );
  };

  const clearForm = (props?: any) => {
    setCheckboxValue([]);
    props.onFilter({});
  };

  const renderInitialValues = (items: Filter[]) => {
    const initialValues: any = {};
    items.map((filter: Filter) => (initialValues[filter.id] = null));
    setInit(initialValues);
  };

  const onSubmit = (data: any) => {
    props.onFilter(data);
    setOpenFilterBox(false);
  };

  return (
    <div className={classes.searchBox}>
      <Grid
        container
        style={{ flexGrow: 2, maxWidth: '100%', margin: 0 }}
        item
        spacing={1}
        xs={12}
        sm={6}
      >
        <form style={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)}>
          <Grid
            style={{ marginRight: 0, marginLeft: 0 }}
            container
            item
            spacing={1}
            alignItems={'center'}
            xs={12}
          >
            <Grid item>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
            </Grid>
            {baseFilter.type === 'input' && (
              <Grid item style={{ flexGrow: 2 }}>
                <InputBase
                  inputRef={register({ required: false })}
                  name={baseFilter.id}
                  placeholder={baseFilter.placeholder}
                  fullWidth
                  defaultValue={null}
                />
              </Grid>
            )}

            {baseFilter.type === 'number' && (
              <Grid item style={{ flexGrow: 2 }}>
                <InputBase
                  inputRef={register({ required: false })}
                  name={baseFilter.id}
                  placeholder={baseFilter.placeholder}
                  type={baseFilter.type}
                  fullWidth
                />
              </Grid>
            )}
          </Grid>
        </form>
      </Grid>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <Button
            type="button"
            onClick={handleClick}
            className={classes.iconButton}
            aria-label="search"
          >
            {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
          </Button>
          {Object.keys(filterValues).length > 3 + mainFiltersCount && (
            <IconButton
              className={classes.iconButton}
              aria-label="cancelFilter"
              onClick={() => {
                onFilter({ page: 0, size: 10 });
                reset({});
              }}
              title="پاک کردن فیلتر"
            >
              <Icon
                path={mdiClose}
                size={1}
                className={classes.closeIcon}
              />
            </IconButton>
          )}
          {openFilterBox ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={clsx(classes.filterBox, {
                  [classes.filterOpen]: openFilterBox,
                })}
              >
                <Grid
                  container
                  spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
                >
                  {renderFromItems(filters, props)}
                  <Grid
                    xs={12}
                    item
                    style={{
                      display: 'flex',
                      marginTop: '20px',
                      marginBottom: '20px',
                      marginRight: 'auto',
                    }}
                  >
                    <div style={{ display: 'flex', flexGrow: 1 }} />
                    <div style={{ padding: '0 5px' }}>
                      <Button
                        fullWidth
                        style={{ marginLeft: '50px' }}
                        variant="contained"
                        size="large"
                        type="button"
                        onClick={() => {
                          reset({});
                          onFilter({});
                          setCheckboxValue([]);
                        }}
                        disabled={
                          Object.keys(
                            flattenObject(removeEmptyValueObject(watch()))
                          ).length === 0
                        }
                      >
                        {'پاک‌ کردن فرم'}
                      </Button>
                    </div>
                    <div style={{ padding: '0 5px' }}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="secondary"
                        autoFocus
                        size="large"
                        data-cy="search"
                        disabled={
                          Object.keys(
                            flattenObject(removeEmptyValueObject(watch()))
                          ).length === 0
                        }
                      >
                        {'جستجو'}
                        {false && <CircularProgress size={24} />}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </form>
          ) : null}
        </div>
      </ClickAwayListener>
    </div>
  );
}

export default RenderFilters;
